import React, {useEffect, useRef, useState} from 'react';
import {hungerTier} from '../hungerEffects';

const SURGE_MS = 1400;

/**
 * Voile rouge sur les bords de l'écran selon la Soif, et pulsation brève quand elle monte.
 * Purement décoratif : ne capte aucun clic.
 */
const VtmHungerVeil = ({hunger}) => {
  const previous = useRef(hunger);
  const [surge, setSurge] = useState(0);

  useEffect(() => {
    const rose = hunger > previous.current;
    previous.current = hunger;
    if (!rose) return undefined;
    setSurge(Date.now());
    const timer = setTimeout(() => setSurge(0), SURGE_MS);
    return () => clearTimeout(timer);
  }, [hunger]);

  const tier = hungerTier(hunger);
  return (
    <>
      {tier > 0 && <div className={`vtmHungerVeil tier${tier}`} aria-hidden="true" />}
      {surge > 0 && <div key={surge} className="vtmHungerSurge" aria-hidden="true" />}
    </>
  );
};

export default VtmHungerVeil;
